'use client'

import React, { createContext, useState, useContext } from 'react'

type ActivityType = {
    currentTab: string
    setCurrentTab: (value: string) => void
}

const Activity = createContext<ActivityType | undefined>(undefined)

export const ActivityProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [currentTab, setCurrentTab] = useState('tab1')

    return (
        <Activity.Provider
            value={{
                currentTab,
                setCurrentTab
            }}
        >
            {children}
        </Activity.Provider>
    )
}

export function useActivity() {
    const context = useContext(Activity)
    if (context === undefined) {
        throw new Error('useCreate must be used within a ActivityProvider')
    }
    return context
}
